import React from "react";
import { crossSellContainerDesktop } from "components/cross-sell-pdp/style.mod.scss";
import Upsell from "../upsell-variant";

const EcoPackageUpsell = ({
  ecoPackage,
  setChoseEcoVariant,
  choseEcoVariant,
  variantPrice,
  variantPriceAtCompare,
  setTotalPrice,
  setTotalCompareAtPrice,
  template,
  crossSellStyle, 
  totalPrice
}) => {

  const { variant } = ecoPackage;

  const differencePrice = variant?.price - variantPrice;

  const addVariant = () => {
    if (choseEcoVariant) {
      setChoseEcoVariant(false);
      if (template === "accessoires") {
        setTotalPrice(totalPrice - variant?.price);
      } else {
        setTotalPrice(totalPrice - differencePrice);
      }
      setTotalCompareAtPrice(variantPriceAtCompare);
    } else {
      setChoseEcoVariant(true);
      if (template === "accessoires") {
        setTotalPrice(totalPrice + variant?.price);
      } else {
        setTotalPrice(totalPrice + differencePrice);
      }
      setTotalCompareAtPrice(variant.compareAtPrice);
    }
  };


  return (
    <div className={crossSellContainerDesktop}>
      <Upsell
        upsell={ecoPackage}
        addVariant={addVariant}
        variantAdded={choseEcoVariant}
        plusPrice={parseFloat(variant.price - variantPrice)}
        crossSellStyle={crossSellStyle}
        type="eco-package"
        ecoPackage={ecoPackage}
        differencePrice={differencePrice}
      />
    </div>
  );
};

export default EcoPackageUpsell;